import { Form, Select } from 'antd';
import { fieldIsRequired } from '../../constants/constants';
import { grades } from '../../constants/grade';
import { selectHerePlaceholder } from '../../constants/translations';

export const GradeSelection = () => (
  <Form.Item
    label="Klasė"
    name={['registration', 'grade']}
    rules={[fieldIsRequired]}
  >
    <Select placeholder={selectHerePlaceholder} showSearch={true}>
      {Object.entries(grades).map(([key, value]) => (
        <Select.Option key={key} value={value}>
          {value}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);
